import React from 'react';
import Box from '@mui/material/Box';

interface CollapseProps {
  open: boolean;
  children: React.ReactNode;
  withTransition?: boolean;
}

function Collapse({ open, children, withTransition = true }: CollapseProps) {
  return (
    <Box
      aria-hidden={open ? 'false' : 'true'}
      sx={{
        display: 'grid',
        gridTemplateRows: open ? '1fr' : '0fr',
        transition: withTransition ? 'grid-template-rows 220ms ease-out' : 'none',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <div style={{ minHeight: 0 }}>{children}</div>
    </Box>
  );
}

export default Collapse;
